export const REQUIRE_SAMPLE_CONSTANT = "REQUIRE_SAMPLE_CONSTANT";
export const SAMPLE_CONSTANT_SUCCESS = "SAMPLE_CONSTANT_SUCCESS";
export const SAMPLE_CONSTANT_FAIL = "SAMPLE_CONSTANT_FAIL"